import React from "react";

const ServiceabilityModal = ({
  open,
  onClose,
  title = "Address is not Serviceable",
  message = "Sorry, this address is outside our current service area. Please choose a different address.",
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/45 px-4 py-6">
      <div className="w-full max-w-[520px] rounded-[28px] bg-[#fff7ea] p-6 shadow-[0_24px_70px_rgba(0,0,0,0.22)] sm:p-8">
        <h2 className="max-w-[320px] text-[26px] font-extrabold leading-[1.2] tracking-[-0.03em] text-[#1a1a1a] sm:text-[30px]">
          {title}
        </h2>
        <p className="mt-6 max-w-[360px] text-[18px] leading-[1.6] text-[#3e3e3e]">
          {message}
        </p>
        <div className="mt-8 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full px-4 py-2 text-[24px] font-medium text-[#8b6a00] transition hover:bg-[#f6edd8]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceabilityModal;
